import React from "react";
import SingleUser from "./SingleUser";
import { ToastContainer, toast } from "react-toastify";

function UserList({ data, teamMembers, id, teamCreatror }) {
  const notify = (msg, type) => toast[type](msg);
  return (
    <>
      <div className="flex flex-col items-between gap-2  overflow-y-scroll h-4/5 p-2 ">
        {data.map((user) => (
          <SingleUser
            key={user.id}
            user={user}
            teamMembers={teamMembers}
            id={id}
            teamCreatror={teamCreatror}
            notify={notify}
          />
        ))}
      </div>
    </>
  );
}

export default UserList;
